import React, { useState, useEffect, useContext } from "react";
import { ethers } from "ethers";
import {
  Box,
  Select,
  Spinner,
  Text,
  VStack,
  Center,
} from "@chakra-ui/react";
import { AppContext } from "../../AppContext";
import JakobFactory from "../../contracts/WalletFactoryArbitrum.json";


const WalletSelector = ({ onSelectWallet }) => {
  const [deployedWallets, setDeployedWallets] = useState([]);
  const [loading, setLoading] = useState(true);
  const { fastestWebSocket } = useContext(AppContext);
  
  const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);
  const walletFactoryContract = new ethers.Contract(
    JakobFactory.address,
    JakobFactory.abi,
    provider
  );

  useEffect(() => {
    const fetchDeployedWallets = async () => {
      try {
        setLoading(true);
        const wallets = await walletFactoryContract.getDeployedWallets();
        setDeployedWallets(wallets);
      } catch (error) {
        console.error("Error fetching deployed wallets:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDeployedWallets();
  }, []);

  return (
    <Box fontFamily="Sentinel" w="100%">
      

      {loading ? (
        <Center>
          <VStack>
            <Spinner size='sm' />
            <Text fontSize='sm'>Loading wallets...</Text>
          </VStack>
        </Center>
      ) : (
        <Select
        border='1px solid dodgerblue'
        fontFamily={'Sentinel'}
        size='sm'
          placeholder="Select account"
          onChange={(e) => onSelectWallet(e.target.value)}
        >
          {deployedWallets.map((wallet, index) => (
            <option key={index} value={wallet.walletAddress}>
              {wallet.contractName} ({wallet.walletAddress.slice(0, 6)}...{wallet.walletAddress.slice(-4)})
            </option>
          ))}
        </Select>
      )}
    </Box>
  );
};

export default WalletSelector;
